import { ChevronDown } from 'lucide-react';
import { RefObject, useCallback } from 'react';

import { cn } from '@/lib/utils'; // Assuming a utility like clsx or tailwind-merge

type Props = {
  scrollRef: RefObject<HTMLDivElement>;
};

export default function MouseScrollIndicator({ scrollRef }: Props) {
  const scrollToTheBottom = useCallback(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [scrollRef]);

  return (
    <button
      className={cn(
        'flex animate-slide-in-top items-center justify-center rounded-full bg-livelinx-orange200 font-bold opacity-0 delay-1000 duration-1000'
      )}
      onClick={scrollToTheBottom}
      aria-label="Scroll to bottom"
    >
      <ChevronDown className="my-2 size-10 bg-transparent text-white" />
    </button>
  );
}
